export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    document.querySelector('.nav-menu__button__holder').addEventListener("click",function(){
      document.querySelector('.nav-menu').classList.toggle('active')
      document.querySelector('.nav-menu__button').classList.toggle('close')
      document.querySelector('body').classList.toggle('activeMenu')
    })

    let x = document.querySelector('.two3rdsPlusMenu__menu__item--current')
    if(x){
      x.addEventListener("click",function(){
        document.querySelector('.two3rdsPlusMenu__menu').classList.toggle('active')
      })
    }
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/common.js